import React, { useEffect, useState } from "react";
import Select from 'react-select';
import moment from 'moment';

import PanelTemplate from "../../templates/Panel";
import Table from "../../components/Table";
import Box from "../../components/Box";
import Button from "../../components/Button";
import PageHeader from "../../components/PageHeader";
import FilterSimple from "../../components/FilterSimple";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { ModalDelete } from "../../components/ModalDelete";
import { getToken, hasPermission } from "../../services/auth";
import Pagination from "../../components/Pagination";
import { ModalCreateCustomer } from "../../components/ModalCreateCustomer";

const types = [
    {label: 'Fornecedor de gravação', value: 'customization'},
    {label: 'Fornecedor de produto', value: 'product'},
    {label: 'Cliente', value: 'customer'},
    {label: 'Faturamento', value: 'billing'}
];

export const CustomerList = () => {
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState('');

    const [customers, setCustomers] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [data, setData] = useState({header: [], rows: []});

    const [showCreateCustomer, setShowCreateCustomer] = useState(false);

    const [customerName, setCustomerName] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [customerEmail, setCustomerEmail] = useState('');
    const [customerCompanies, setCustomerCampanies] = useState([]);
    const [customerAdmin, setCustomerAdmin] = useState(null);
    const [customerType, setCustomerType] = useState([]);

    const [customerToDelete, setCustomerToDelete] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [perPage, setPerPage] = useState(20);
    const [totalResults, setTotalResults] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [hasPrevPage, setHasPrevPage] = useState(false);

    const [selectedIds, setSelectedIds] = useState([]);
    const [showConfirmMultipleDelete, setShowConfirmMultipleDelete] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        getCustomers();
    }, [currentPage,filters]);

    useEffect(() => {
        if(!showCreateCustomer) clean();
    }, [showCreateCustomer]);

    useEffect(() => {
        setTypesAndAdmin();
    }, [customerCompanies]);

    useEffect(() => {
        generateData();
    }, [customers]);

    const setTypesAndAdmin = () => {
        let selectedAdmin = customerAdmin;
        let selectedTypes = [...customerType];
        let selectedCompanies = companies.filter(company => customerCompanies.includes(company.id));
        selectedCompanies.map(selectedCompany => {
            if(selectedCompany.admin_id !== null){
                selectedAdmin = selectedCompany.admin_id;
            }
            selectedCompany.type.map(type => {
                if(!selectedTypes.includes(type)){
                    selectedTypes.push(type);
                }
            });
        });
        setCustomerType(selectedTypes);
        setCustomerAdmin(selectedAdmin);
    }

    const generateData = () => {
        let header = ['Código', 'Nome', 'E-mail', 'Telefone', 'Empresa', 'Cadastrado em', 'Atualizado em'];
        const rows = [];

        if(hasPermission('delete_customer')){
            header.push('');
        }

        customers.map(customer => {
            const companies = customer.companies.map(company => company.trade_name).join(', ');

            let buttons = [];

            if(hasPermission('delete_customer')){
                buttons.push(
                    <Button type={`delete`} svg={`delete`} action={() => setCustomerToDelete(customer.id)} />
                )
            }
            rows.push({
                data: [
                    customer.code,
                    customer.name,
                    customer.email,
                    customer.phone,
                    companies,
                    customer.created_at ? moment(customer.created_at).format('DD/MM/YYYY HH:mm') : '',
                    customer.created_at ? moment(customer.updated_at).format('DD/MM/YYYY HH:mm') : ''
                ],
                buttons,
                id: customer.id,
                to: `/customer/edit/${customer.id}`
            })
        });

        setData({header, rows});
    }

    const getCustomers = () => {
        setCustomers([]);
        setLoading(true);

        api.get(`/customer/paginate?${filters}&page=${currentPage}`).then(res => {
            setCustomers(res.data.resources.data);
            setCurrentPage(res.data.resources.current_page);
            setLastPage(res.data.resources.last_page)
            setPerPage(res.data.resources.per_page)
            setTotalResults(res.data.resources.total)
            setHasNextPage(res.data.resources.next_page_url !== null);
            setHasPrevPage(res.data.resources.prev_page_url !== null);
        }).catch(error => {
            
        }).then(() => setLoading(false));
    }

    const clean = () => {
        setCustomerName('');
        setCustomerEmail('');
        setCustomerPhone('');
        setCustomerCampanies([]);
    }

    const deleteCustomer = () => {
        setLoading(true);

        api.delete(`/customer/${customerToDelete}`).then(res => {
            setCustomerToDelete(null);
            getCustomers();
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const handleSetFilter = value => {
        setCurrentPage(1);
        setFilters(value);
    }

    const deleteMultipleCustomers = () => {
        setLoading(true);

        api.delete(`/customer/multiple`, {
            data: {
                ids: selectedIds
            }
        }).then(res => {
            setSelectedIds([]);
            getCustomers();
            setShowConfirmMultipleDelete(false);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    const exportCustomers = () => {
        window.open(`${process.env.REACT_APP_URL}/customer/export?_token=${getToken()}`);
    }

    const customerStored = customer => {
        navigate(`/customer/edit/${customer.id}`);
        setShowCreateCustomer(false);
    }

    return (
        <>
            <ModalDelete
                show={customerToDelete !== null}
                action={deleteCustomer}
                loading={loading}
                close={() => setCustomerToDelete(null)}
            />
            <ModalDelete
                show={showConfirmMultipleDelete}
                text={<p>Tem certeza que deseja apagar <strong>{selectedIds.length} {selectedIds.length > 1 ? 'pessoas' : 'pessoa'}</strong>?</p>}
                action={deleteMultipleCustomers}
                loading={loading}
                close={() => setShowConfirmMultipleDelete(false)}
            />
            <ModalCreateCustomer
                show={showCreateCustomer}
                close={() => setShowCreateCustomer(false)}
                customerStored={customerStored}
            />
            <PanelTemplate id="customer-list">
                <PageHeader
                    left={
                        <FilterSimple 
                            params={[
                                {name: 'Nome', key: '[name]', type: 'text' },
                                {name: 'E-mail', key: '[email]', type: 'text' },
                                {name: 'Código', key: '[code]', type: 'text' },
                                {name: 'Nome fantasia da empresa', key: '[related][companies.trade_name]', type: 'text' },
                                {name: 'Razão social da empresa', key: '[related][companies.company_name]', type: 'text' },
                            ]}
                            filter={handleSetFilter}
                        />
                    }

                    right={
                        <>
                            {hasPermission('delete_customer') && selectedIds.length > 0 &&
                                <Button 
                                type={`secondary`} 
                                size={`small`} 
                                svg={`delete`}
                                text={`Excluir ${selectedIds.length} selecionados`} 
                                action={() => setShowConfirmMultipleDelete(true)}  
                                />
                            }
                            {hasPermission('export_customer') &&
                                <Button type={`secondary`} size={`small`} text={`Exportar pessoas`} action={exportCustomers}  />
                            }
                            {hasPermission('create_customer') &&
                                <Button type={`primary`} size={`small`} text={`Cadastrar pessoa`} svg="plus-white" action={() => setShowCreateCustomer(true)}  />
                            }
                        </>
                    }
                />
                
                <Box className={`no-padding with-pagination`}>
                    <Table 
                        header={data.header} 
                        rows={data.rows} 
                        loading={loading}
                        checks={hasPermission('delete_customer')}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                    />
                </Box>
                {!loading &&
                    <Pagination
                        currentPage={currentPage}
                        lastPage={lastPage}
                        perPage={perPage}
                        totalResults={totalResults}
                        hasNextPage={hasNextPage}
                        hasPrevPage={hasPrevPage}
                        setCurrentPage={setCurrentPage}
                    />
                }
            </PanelTemplate>
        </>
    );
}

export default CustomerList;